// src/pages/Home.jsx
import React from 'react';
import Hero from '../components/Hero/Hero';
import Features from '../components/Features/Features';
import EventList from '../components/EventList/EventList';
import About from '../components/About/About';
import Contact from '../components/Contact/Contact';
import LogoSlider from '../components/LogoSlider';
import PartnerProgram from '../components/Partner/PartnerProgram';
// import LogoSlider from '../components/LogoSlider';

const Home = () => {
  return (
    <>
      {/* <Hero /> */}
      <PartnerProgram />
      <LogoSlider />
      <Features />
      
      {/* <EventList /> */}
      <About />
      <Contact />
    </>
  );
};

export default Home;